import cx from 'classnames';
import Icon from '@components/common/Icon';
import ItemCountBadge from '../ItemCountBadge';
import {STORE_URL} from '@util/URLUtils';

const classList = {
    header: 'flex h-full justify-between items-center px-4 font-semibold text-center bg-grey-darkest absolute pin-t pin-r pin-l',
    divider: 'border-l border-solid border-grey',
    label: 'flex items-center h-full inline-block px-4 text-inherit hover:text-inherit',
    button: 'flex h-full items-center inline-block px-6 pr-8 font-semibold text-center relative'
};

const CartHeader = ( {cartItemCount}, {miniCartEnabled} ) => {
    const openIconAttributes = {};

    if ( miniCartEnabled ) {
        openIconAttributes.name = 'arrow-left-double';
        openIconAttributes['data-tooltip'] = 'Show';
    }

    const cartBtnClass = cx( classList.button, {
        'cursor-pointer': miniCartEnabled
    } );

    return (
        <li data-testid="cart-header" id="nav-item--cart"
            className="nav-item--cart flex items-center h-full relative text-white nowrap">

            <div className={`nav-item--cart-button ${cartBtnClass}`} data-testid="nav-item--cart-actions">
                <a href={STORE_URL} className="whitespace-no-wrap flex-shrink inline-block">
                    <Icon.ui name="shopping-cart" className="text-xl"/>
                    <ItemCountBadge className="fade-in" count={cartItemCount}/>
                </a>
                <Icon.ui
                    data-action="toggle-cart"
                    data-testid="minicart-open-action-icon"
                    {...openIconAttributes}
                    className="fade-in ml-4 text-lg min-h-full"/>
            </div>
            <div className={`nav-item--cart-header ${classList.header} ${classList.divider}`}>
                <a href={STORE_URL} className="w-6 whitespace-no-wrap flex-shrink inline-block">
                    <Icon.ui name="shopping-cart" className="text-xl"/>
                    <ItemCountBadge className="fade-in" count={cartItemCount}/>
                </a>
                <a href={STORE_URL} className="nav-item--cart-label">Cart Summary</a>
                <Icon.ui data-action="toggle-cart"
                         data-tooltip="Hide"
                         id="minicart-close-action-icon"
                         name="arrow-right-double"
                         className="mr-2 text-lg cursor-pointer"/>
            </div>
        </li>
    );
};

export default CartHeader;
